/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const DialogDismissButtonTemplate = `
<button aria-label="Close" class="close dismiss-button" type="button">
<sirius-icon shape="close-x" set="dds" size="22" aria-hidden="true"></sirius-icon>
</button>
`;      
